import { LLPA_CAP_ACTION_TYPE } from '../actions';

const initialState = {};

const llpaCapSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LLPA_CAP_ACTION_TYPE.GET_SCHEMA:
      return payload || initialState;

    default:
      return state;
  }
};

export default llpaCapSchemaReducer;
